export const USER_TOKEN = 'userTokenFizika';